import { useState } from 'react';
import * as S from '~/components/Chat/Chat01/SubMenu/SubMenu.styled';
import { Icon } from '~/components/atomic';
import { Tooltip } from '~/components/common';
import { useLeaveGroupChatRoomMutation } from '~/features/chatRoom';
import { useModal } from '~/hooks';
import { LeaveChatRoomRequest } from '~/types';
import { useCommonChatStore, useGroupChatStore } from '~/store';

interface GroupChatSubMenuProps {
  email: string;
  chatroomId: string;
  isNotificationOn: boolean;
  handleNotifyClick: () => void;
  isSafeChatOn: boolean;
  handleSafeModeClick: () => void;
  handleReportClick: () => void;
}

export default function GroupChatSubMenu({
  email,
  chatroomId,
  isNotificationOn,
  handleNotifyClick,
  isSafeChatOn,
  handleSafeModeClick,
  handleReportClick,
}: GroupChatSubMenuProps) {
  const { openModal } = useModal();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const setShowSubMenu = useCommonChatStore((state) => state.setShowSubMenu);

  const { setShowGroupInfo, setShowChatShareOpen } = useGroupChatStore(
    (state) => ({
      showGroupInfo: state.showGroupInfo,
      setShowGroupInfo: state.setShowGroupInfo,
      setShowChatShareOpen: state.setShowChatShareOpen,
    }),
  );

  const { mutate } = useLeaveGroupChatRoomMutation();

  const fetchLeaveRoomClick = async () => {
    if (!chatroomId) return;

    const requestData: LeaveChatRoomRequest = {
      chatroom_id: chatroomId,
    };

    mutate(requestData);
  };

  const handleLeaveRoomClick = () => {
    openModal({
      title: 'Leave',
      content: 'Are you sure you want to leave?',
      buttonName: 'Leave',
      click: fetchLeaveRoomClick,
    });
  };

  return (
    <>
      <S.Container>
        <S.Wrapper>
          <S.SubMenu>
            <span>Notification</span>
            <S.ToggleButtonBox>
              <S.Input
                type='checkbox'
                id='NotiToggleButton_Group'
                hidden
                checked={isNotificationOn}
                onChange={handleNotifyClick}
              />
              <S.ToggleButton
                htmlFor='NotiToggleButton_Group'
                className='toggleButton'
              >
                <S.Toggle className='toggle' />
              </S.ToggleButton>
            </S.ToggleButtonBox>
          </S.SubMenu>
          <S.SubMenu>
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Safe chat
              <Icon
                iconName='Alert'
                size={16}
                style={{
                  paddingLeft: '8px',
                }}
                onClick={() => setIsTooltipOpen(true)}
              />
            </span>
            <S.ToggleButtonBox>
              <S.Input
                type='checkbox'
                id='safeChat'
                hidden
                checked={isSafeChatOn}
                onChange={handleSafeModeClick}
              />
              <S.ToggleButton htmlFor='safeChat' className='toggleButton'>
                <S.Toggle className='toggle' />
              </S.ToggleButton>
            </S.ToggleButtonBox>
            {isTooltipOpen && (
              <Tooltip
                top={44}
                left={14}
                onClose={() => setIsTooltipOpen(false)}
              >
                Filters out potentially harmful AI-generated chats, including
                sexually explicit or violent content
              </Tooltip>
            )}
          </S.SubMenu>
          <S.SubMenu
            onClick={() => {
              setShowGroupInfo(true);
              setShowSubMenu(false);
            }}
          >
            <span>Group info</span>
          </S.SubMenu>
          <S.SubMenu
            onClick={() => {
              setShowChatShareOpen(true);
              setShowSubMenu(false);
            }}
          >
            <span>Share</span>
          </S.SubMenu>
          <S.SubMenu onClick={handleReportClick}>
            <span>Report</span>
          </S.SubMenu>
          <S.SubMenu className='red' onClick={handleLeaveRoomClick}>
            <span>Leave</span>
          </S.SubMenu>
        </S.Wrapper>
      </S.Container>
    </>
  );
}
